export const PLACEHOLDER = "Escribe aquí tus observaciones";
export const SEND = "Enviar";
